

import React, { useState, useEffect } from 'react';
import './Activities.scss';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from "sweetalert2";
import {
  MdCheckCircle,
  MdRadioButtonUnchecked,
  MdErrorOutline,
  MdList,
  MdEventNote,
  MdCall,
  MdEmail,
  MdGroups,
  MdNotificationsActive
} from 'react-icons/md';
import ReactModal from 'react-modal';

const Activities = () => {

  const baseURL = 
  process.env.NODE_ENV === 'production' 
    ? process.env.REACT_APP_API_URL_PROD 
    : process.env.REACT_APP_API_URL_LOCAL;

    
  const [description, setDescription] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [type, setType] = useState("");
  const [subject, setSubject] = useState("");
  const [reminderTime, setReminderTime] = useState("");
  const[id,setId]= useState("");
  const [activityType, setActivityType] = useState('Tasks');
  const [statusFilter, setStatusFilter] = useState('All');
  const [reminders, setReminders] = useState([]);
  const [activeTab, setActiveTab] = useState('Activities');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedReminder, setSelectedReminder] = useState(null);
  const navigate = useNavigate();
   const [modalMode, setModalMode] = useState('view');

  const now = new Date();
const renderTaskIcon = (reminder, isCurrent) => {
  const isCompleted = reminder.status === 'completed';
  const isOverdue = new Date(reminder.time) < new Date() && !isCompleted;
const isUpcoming = !isCompleted && !isOverdue && !isCurrent;
  const reminderType = (reminder.type || '').toLowerCase();
  const baseIcon = typeIconMap[reminderType] || typeIconMap['default'];

    
  // Define color by state
  const iconColor = isCompleted
    ? '#10b981' // green
    : isOverdue
    ? '#ef4444' // red
    : isCurrent
    ? '#f97316' // orange
    : '#3b82f6'; // blue (upcoming)

  const backgroundColor = isCompleted
    ? '#e6f4ea'
    : isOverdue
    ? '#fdecea'
    : isCurrent
    ? '#fef6e0'
    : '#e8f0fe';

  const baseStyle = {
    width: 36,
    height: 36,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor,
    border: '2px solid white',
    position: 'relative',
    boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
  };

  return (
    <div style={baseStyle}>
      {React.cloneElement(baseIcon, {
        color: iconColor,
        size: 20,
      })}

      {isOverdue && (
        <div
          style={{
            position: 'absolute',
            top: -5,
            left: -5,
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: '#dc2626', // red
            color: 'white',
            fontSize: 12,
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 0 2px rgba(0,0,0,0.2)',
            zIndex: 2,
          }}
          title="Overdue"
        >
          !
        </div>
      )}
            {/* Completed green checkmark */}
      {isCompleted && (
        <div
          style={{
            position: 'absolute',
            bottom: -2,
            right: -2,
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: '#10b981', // green
            color: 'white',
            fontSize: 14,
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 0 2px rgba(0,0,0,0.2)',
            zIndex: 2,
          }}
          title="Completed"
        >
          ✓
        </div>
      )}
            {isUpcoming && (
        <div
          style={{
            position: 'absolute',
           top: -0.9,
            left: -5,
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: '#3b82f6', // blue
            boxShadow: '0 0 4px rgba(59, 130, 246, 0.7)',
            zIndex: 1,
          }}
          title="Upcoming"
        />
      )}
    </div>
  );
};
  const typeIconMap = {
    meeting: <MdGroups size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />,
    call: <MdCall size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />,
    email: <MdEmail size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />,
    default: <MdEventNote size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />,
  };

  const filterOptions = [
    {
      key: 'All',
      icon: <MdList size={18} style={{ verticalAlign: 'middle', marginRight: 4 }} />,
      label: `All (${reminders.length})`,
    },
    {
      key: 'Overdue',
      icon: <MdErrorOutline size={18} color="#e74c3c" style={{ verticalAlign: 'middle', marginRight: 4 }} />,
      label: `Overdue (${reminders.filter((r) => new Date(r.time) < now && r.status === 'pending').length})`,
    },
    {
      key: 'Completed',
      icon: <MdCheckCircle size={18} color="#10b981" style={{ verticalAlign: 'middle', marginRight: 4 }} />,
      label: `Completed (${reminders.filter((r) => r.status === 'completed').length})`,
    },
  ];

  useEffect(() => {
    const fetchAllReminders = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        const { data } = await axios.get(`${baseURL}/api/reminders`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setReminders(data.reminders || []);
      } catch (e) {
        console.error(e);
      }
    };
    fetchAllReminders();
  }, []);


 const toggleTaskCompletion = async (reminderId) => {
  const updatedReminders = [...reminders];
  const reminderIndex = updatedReminders.findIndex((r) => r._id === reminderId);
  if (reminderIndex === -1) return;

  const reminder = updatedReminders[reminderIndex];
  const newStatus = reminder.status === "pending" ? "completed" : "pending";
  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(
      `${baseURL}/api/reminders/status`,
      {
        reminderId: reminder._id,
        detailId: reminder.detailId,
        status: newStatus,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    updatedReminders[reminderIndex] = response.data.reminder;
    setReminders(updatedReminders);
  } catch (error) {
    console.error("Failed to update status", error);
  }
};


  let filtered = reminders;
  if (activityType === 'Updating') filtered = filtered.filter((r) => r.status === 'completed');
  if (statusFilter === 'Completed') filtered = filtered.filter((r) => r.status === 'completed');
  else if (statusFilter === 'Overdue') filtered = filtered.filter((r) => new Date(r.time) < now && r.status === 'pending');
  else if (statusFilter === 'Open') filtered = filtered.filter((r) => new Date(r.time) >= now && r.status === 'pending');

  const sortedReminders = [...filtered].sort((a, b) => new Date(a.time) - new Date(b.time));
  const currentIndex = sortedReminders.findIndex((r) => r.status !== 'completed');

  const grouped = { Today: [], Tomorrow: [], Upcoming: [], Past: [] };
  const today = now.toDateString();
  const tomorrow = new Date(now.getTime() + 86400000).toDateString();

  sortedReminders.forEach((r) => {
    const ds = new Date(r.time).toDateString();
    if (ds === today) grouped.Today.push(r);
    else if (ds === tomorrow) grouped.Tomorrow.push(r);
    else if (new Date(r.time) > now) grouped.Upcoming.push(r);
    else grouped.Past.push(r);
  });

  grouped.Today.sort((a, b) => {
    const getPriority = (r) => {
      const isOverdue = new Date(r.time) < now && r.status === 'pending';
      const isUpcoming = new Date(r.time) >= now && r.status === 'pending';
      const isCompleted = r.status === 'completed';
      if (isOverdue) return 0;
      if (isUpcoming) return 1;
      if (isCompleted) return 2;
      return 3;
    };
    return getPriority(a) - getPriority(b);
  });

  const renderTaskItem = (reminder, idx, isCurrent) => {
    const isCompleted = reminder.status === 'completed';
    const isOverdue = new Date(reminder.time) < now && !isCompleted;
    let StatusIcon;
    if (isCompleted) StatusIcon = <MdCheckCircle color="#10b981" size={20} />;
    else if (isOverdue) StatusIcon = <MdErrorOutline color="#e74c3c" size={20} />;
    else StatusIcon = <MdRadioButtonUnchecked color={isCurrent ? '#fcb124' : '#4a90e2'} size={20} />;

    const formatted = new Date(reminder.time).toLocaleString('en-US', {
      month: 'short', day: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true,
    });

    const reminderType = (reminder.type || '').toLowerCase();
    const typeIcon = typeIconMap[reminderType] || typeIconMap.default;
;
    return (
 <li key={reminder._id} className="task-step">
  <div className="step-icon-wrapper">
    <div className="step-icon">
      {renderTaskIcon(reminder, isCurrent)}
    </div>

    {/* Only show line if not the last item */}
    {idx !== sortedReminders.length - 1 && (
      <div className="step-line" />
    )}
  </div>

  <div className="step-content">
    <div style={{ display: "flex", alignItems: "center",justifyContent:"space-between" }}>
    <p
      className="step-desc"
      onClick={(e) => {
        e.stopPropagation();
        setSelectedReminder(reminder);
        setType(reminder.type || '');
        setSubject(reminder.subject || '');
        setDescription(reminder.description || '');
        setReminderTime(reminder.time || '');
        setId(reminder._id);
        setModalMode('view');
        setModalIsOpen(true);
      }}
      style={{ cursor: 'pointer' }}
    >
      {reminder.subject || 'No Description'}
    </p>
      {!isCompleted && (
    <button
      onClick={(e) => {
        e.stopPropagation(); 
       toggleTaskCompletion(reminder._id);
      }}
      style={{
        padding: "4px 8px",
        fontSize: "12px",
        backgroundColor: "#fcb124",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        
      }}
    >
      Mark as Completed
    </button>
  )}
    </div>
    <p className="step-date">    {reminder.description.length > 20
                                    ? `${reminder.description.slice(0, 20)}...`
                                    : reminder.description}</p>
    <p className="step-date">{`Reminder at ${new Date(reminder.time).toLocaleString()}`}</p>
  </div>
</li>

    );
  };

  const renderGroupedTasks = () => {
    if (!sortedReminders.length) {
      return (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <img src="/no-tasks.svg" alt="No Tasks" width="200" />
          <p>No reminders available</p>
        </div>
      );
    }
    let global = 0;
    return (
      <div className="task-chain">
        <h3 className="task-title" style={{ textAlign: 'center' }}>{activityType === 'Tasks' ? 'Tasks' : 'Updates'}</h3>
        {Object.entries(grouped).map(([groupName, tasks]) =>
          tasks.length ? (
            <div key={groupName} className="task-group">
              <h3 className="date-heading">{groupName}</h3>
              <ul>
                {tasks.map((r) => {
                  const isCurrent = global === currentIndex;
                  const item = renderTaskItem(r, global, isCurrent);
                  global++;
                  return item;
                })}
              </ul>
            </div>
          ) : null
        )}
      </div>
    );
  };
  

  const scheduleNotification = (reminder) => {
    const reminderTime = new Date(reminder.time).getTime();
    const currentTime = new Date().getTime();
    const timeDiff = reminderTime - currentTime;
  
    if (timeDiff > 0) {
      setTimeout(() => {
        showNotification(reminder.description);
      }, timeDiff);
    }
  };
  const showNotification = (message) => {
    if (Notification.permission === "granted") {
      new Notification("Reminder Alert", { body: message });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          new Notification("Reminder Alert", { body: message });
        }
      });
    }
  };


const handleUpdateReminder = async () => {
  const token = localStorage.getItem("token");
  if (!token || !selectedReminder) return;

  try {
    const response = await axios.put(
      `${baseURL}/api/reminders/${selectedReminder._id}`,
      {
        type,
        subject,
        description,
        time: reminderTime,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      }
    );

    const updated = response.data.reminder;
    setReminders((prev) =>
      prev.map((rem) => (rem._id === updated._id ? updated : rem))
    );

    setModalIsOpen(false);

    Swal.fire({
      icon: "success",
      title: "Reminder Updated",
      text: "Reminder updated successfully",
      confirmButtonColor: "#FCB124",
    });
  } catch (error) {
    console.error("Error updating reminder:", error);
    Swal.fire({
      icon: "error",
      title: "Update Failed",
      text: "Could not update reminder",
    });
  }
};

  return (
    <div className="activities-container">
      <div className="crm-nav">
        {['Dashboard', 'Deals', 'Activities'].map((tab) => (
          <div
            key={tab}
            className={`crm-menu ${activeTab === tab ? 'active' : ''}`}
            onClick={() => {
              setActiveTab(tab);
              navigate(tab === 'Dashboard' ? '/crm' : `/${tab.toLowerCase()}`);
            }}
          >
            {tab}
          </div>
        ))}
      </div>

      <div className="show-section">
        {['Tasks', 'Updating'].map((t) => (
          <button key={t} className={activityType === t ? 'active' : ''} onClick={() => setActivityType(t)}>
            {t}
          </button>
        ))}
      </div>

      <div className="status-filters">
        {filterOptions.map(({ key, icon, label }) => (
          <button key={key} className={statusFilter === key ? 'active' : ''} onClick={() => setStatusFilter(key)}>
            {icon}{label}
          </button>
        ))}
      </div>

      {renderGroupedTasks()}

     <ReactModal
  isOpen={modalIsOpen}
  onRequestClose={() => setModalIsOpen(false)}
  className="task-modal"
  overlayClassName="modal-overlay"
  ariaHideApp={false}
>
  {selectedReminder && (
    <div className="popup-form">
      <h1 className="reminderHeader">
        <MdNotificationsActive size={20} style={{ marginRight: 8 }} />
        Reminder
      </h1>

      {modalMode === 'edit' ? (
        <>
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="">Select Type</option>
            <option value="Meeting">Meeting</option>
            <option value="Call">Call</option>
            <option value="Email">Email</option>
          </select>

          <input
            type="text"
            placeholder="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <input
            type="text"
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <label htmlFor="date">Date & Time</label>
          <input
            className="date-input"
            type="datetime-local"
            id="date"
            value={reminderTime}
            onChange={(e) => setReminderTime(e.target.value)}
            required
          />


          <div className="popup-buttons">
            <button className="task-save" onClick={handleUpdateReminder}>Save</button>
            <button className="task-cancel" onClick={() => setModalIsOpen(false)}>Cancel</button>
          </div>
        </>
      ) : (
        <>
          <div className="view-container">
            <p><strong>Type:</strong> {selectedReminder.type || 'N/A'}</p>
            <p><strong>Subject:</strong> {selectedReminder.subject || 'N/A'}</p>
            <p><strong>Description:</strong> {selectedReminder.description || 'N/A'}</p>
            <p><strong>Date & Time:</strong> {new Date(selectedReminder.time).toLocaleString()}</p>
            <p><strong>Status:</strong> {selectedReminder.status}</p>
          </div>
          <div className="popup-buttons">
            <button className="task-save" onClick={() => setModalMode('edit')}>Edit</button>
            <button className="task-cancel" onClick={() => setModalIsOpen(false)}>Close</button>
          </div>
        </>
      )}
    </div>
  )}
</ReactModal>
    </div>
  );
};

export default Activities;